














import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import QuickTable from "../../../../../components/table/table.vue";
@Component({
	name:'instituteBooks',
	components: {
		QuickTable
	}
})
export default class InstituteBooks extends AbpBase {
	initData:any = {
		columns: [
			
		]
	}
	//导出
    Export() {
    	let params:any = (this as any).$refs.table.initData.searchData;
        (this as any).$root.Export(params, '', '制度制定情况登记表', 'xlsx');
    }
}
